<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">상품관리</span>
            <span class="txt">센터에서 이용 중인 이용권과 패키지를 등록 및 수정하고 설정할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingGoodsUse' }" class="on">이용권 관리</router-link>
            <!-- <router-link :to="{ name: 'SettingGoodsPackage' }">패키지 관리</router-link> -->
            <router-link :to="{ name: 'SettingGoodsCategory' }">카테고리 관리</router-link>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <select-form
                        :select-data="['전체', '판매중', '판매정지']"
                        :select-value="['', 'true', 'false']"
                        :selected-value.sync="filter.stockUseYn"
                        @update:set="(v) => load()"
                    ></select-form>
                    <select-form
                        :select-data="['이용권 전체', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                        :select-value="['', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                        :selected-value.sync="filter.ticketType"
                        @update:set="(v) => load()"
                    ></select-form>
                    <select-form
                        :select-data="['카테고리 전체', '분류없음', ...categorysData]"
                        :select-value="['', '0', ...categorysValues]"
                        :selected-value.sync="filter.centerProductCategoryTemplateId"
                        @update:set="(v) => load()"
                    ></select-form>
                    <select-form
                        :select-data="['이용권 전체', '키오스크 사용 가능', '키오스크 사용 불가']"
                        :select-value="['', 'true', 'false']"
                        :selected-value.sync="filter.kioskUsable"
                        @update:set="(v) => load()"
                    />
                    <select-form
                        :select-data="['유형·이름순 정렬', '등록일순 정렬']"
                        :select-value="['productName', 'createAt']"
                        :selected-value.sync="filter.sortColumn"
                        @update:set="(v) => load()"
                    ></select-form>
                    <button class="com-search-reset" type="button" @click="filter = getFilterDefault()"></button>
                </div>
                <div class="com-search-input">
                    <input v-model="filter.searchStr" placeholder="검색어 입력" type="text" @keydown.enter="load" />
                    <button class="search-btn" type="button" @click="load">검색</button>
                </div>
            </div>
        </div>

        <div class="com-btn-area">
            <!--
            고객 요청에 의해서 엑셀 다운로드 기능 삭제
            <div class="left-box">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
            </div>
            -->
            <div class="right-box">
                <router-link :to="{ name: 'SettingGoodsUseDetail' }" class="com-btn blue">이용권 등록</router-link>
            </div>
        </div>

        <div class="lesson-info-content">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <ul v-else class="list">
                <!-- type-1: 개인, type-2: 그룹, type-3: 패키지, type-4: 회원권, type-5: 듀엣, type-6: OT -->
                <li
                    v-for="(item, index) in data.items"
                    :key="index"
                    @click="
                        $router.push({
                            path: '/madmin/setting/goods/use/detail',
                            // params: { prodNo: item.cp_center_prod_id },
                            query: { prodNo: item.cp_center_prod_id },
                        })
                    "
                >
                    <span v-if="!item.cp_stoc_use_yn" class="no">미사용</span>
                    <span class="icon-box">
                        <span class="ico type-K" v-if='item.cp_kiosk_usable'>키오스크</span>

                        <span :class="'type-' + item.cp_ticket_type_cd" class="ico">
                            {{ ticketData[ticketTypes.indexOf(item.cp_ticket_type_cd)] }}
                        </span>
                    </span>
                    <span :class="'type-' + item.cp_ticket_type_cd" class="title">{{ item.cp_namee }}</span>
                    <span v-if="['L', 'S'].includes(item.cp_ticket_type_cd)" class="info">
                        유효기간 {{ item.cp_period_cnt }}{{ item.cp_period_type_cd == 'M' ? '개월' : '일' }}
                    </span>
                    <span v-else class="info">
                        <span v-if="item.cp_less_cnt_type_cd !== 'U'">
                            <span v-if="item.cp_less_cnt_type_cd === 'T'">총</span>
                            <span v-if="item.cp_less_cnt_type_cd === 'W'">주</span>
                            {{ item.cp_less_cnt }}회
                        </span>
                        <span v-else>무제한</span>
                        / 유효기간 {{ item.cp_period_cnt }}{{ item.cp_period_type_cd == 'M' ? '개월' : '일' }}
                        <span v-if="!!item.cp_category_temp_nm">
                            / {{ item.cp_category_temp_nm.replace(/\|/g, ' / ') }}
                        </span>
                    </span>
                    <span class="num">
                        {{ item.cp_sell_price | numberFormatFilter }}
                        <small>원</small>
                    </span>
                </li>
            </ul>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'SettingGoodsUse',
    components: { LoadingSpinner },
    props: {},

    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
    },
    data() {
        return {
            isLoading: false,
            ticketData: [],
            ticketTypes: [],
            categorysData: [],
            categorysValues: [],
            filter: {},
            data: [],
            pagingInfo: { ...pagingInfo },
        };
    },
    async beforeMount() {
        this.filter = this.getFilterDefault();
        this.pagingInfo.limit = 12;

        (await this.$getSystemCode({ center_prod: ['ticket_type_cd'] })).forEach((o) => {
            this.ticketData = o.map((e) => e.codeDesc);
            this.ticketTypes = o.map((e) => e.codeName);
        });

        this.getCategoryTemplate();
    },
    mounted() {
    },
    activated() {
        this.load();
    },
    methods: {
        reset() {
            this.$router.push({
                query: this.filter,
                replace: true,
            });
        },
        getFilterDefault() {
            return Object.keys(this.$route.query).length === 0
                ? {
                      centerId: this.centerId,
                      stockUseYn: 'true',
                      ticketType: '',
                      centerProductCategoryTemplateId: '',
                      sortColumn: 'productName',
                      sortType: 'ASC',
                      searchStr: '',
                  }
                : this.$route.query;
        },
        load() {
            this.filter.sortType = this.filter.sortColumn == 'createAt' ? 'DESC' : 'ASC';
            api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: {...this.pagingInfo, ...this.filter},
            }).then((res) => {
                this.isLoading = false;
                this.setPageParams(res.data);
                this.data = res.data;
            }).catch((res) => {
                this.isLoading = false;
                if (res.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                console.error(res);
            });
        },
        getCategoryTemplate() {
            api.get(`/admin/api/center/${this.centerId}/product/category/template`).then((res) => {
                res.data.forEach((o) => {
                    this.categorysData.push(o.name);
                    this.categorysValues.push(o.centerProductCategoryTemplateId);
                });
            }).catch((res) => {
                if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                console.error(res);
            });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.load();
        },
        /*
        // 엑셀 다운로드 기능
        async excelDownload() {
            let excelDownloadArray = [];
            const { data } = await api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: {
                    ...this.filter,
                    page: 1,
                    limit: 10000
                }
            });

            data.items.forEach(item => {
                const temp = {};
                temp['이용권구분'] = this.ticketData[this.ticketTypes.indexOf(item.cp_ticket_type_cd)];
                temp['이용권명'] = item.cp_namee;
                temp['카테고리'] = (item.cp_category_temp_nm || '').replace(/\|/g, ' / ');
                temp['유효기간'] = item.cp_less_cnt + (item.cp_period_type_cd == 'M' ? '개월' : '일');
                temp['횟수'] = numberFormat(item.cp_less_cnt);
                temp['금액'] = numberFormat(item.cp_sell_price);

                excelDownloadArray.push(temp);
            });

            // [Key:value, ...]
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                {wch: 12}, {wch: 24}, {wch: 24}, {wch: 12}, {wch: 12}, {wch: 14}
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [
                {hpx: 30},
            ];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, "이용권관리");
            XLSX.writeFile(wb, '이용권관리.xlsx');
        },
        */
    },
};
</script>
<style lang="scss"></style>
